// 静态路由
const isSpecialDomain = window.location.hostname === 'localhost'
const isMobile=navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
const getHomeComponent=()=> {
    if(isSpecialDomain){
        if(isMobile){
            return  import('../views/mobile/Index.vue') 
        }
        else{
            return import('../views/pages/Index.vue')
        }
    }
    else{
        return import('../views/Index.vue');
    }
  }

export const staticRouter = [
      {
        path:'/',
        component:() => 
            getHomeComponent(),
        meta: { 
            title: 'Sushi Takeaway & Levering',
            description: 'tilbyder frisk sushi takeaway og levering. Bestil online og nyd sushi menus, ruller og japanske favoritter.',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi',
            h1Title: 'Sushi Takeaway & Levering'
        }
    },
    {
        path:'/:id',
        component:() => import('../views/Index.vue'),
        meta: { 
            title: 'Sushi Takeaway & Levering',
            description: 'Bestil frisk sushi online fra Lucky Satr. Vi tilbyder takeaway og leveringstjenester',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad',
        }
    },
    {
        path:'/page/index',
        component:() => import('../views/pages/Index.vue'),
         meta: { 
            title: 'Sushi Takeaway & Levering',
            description: 'Lucky Satr tilbyder frisk sushi takeaway og levering. ',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/coupon/:id',
        component:() => import('../views/coupon/Index.vue'),
        meta: { 
            title: 'Rabatkoder',
            description: 'Se vores seneste rabatkoder og tilbud.',
            keywords: 'rabatkoder, rabat, sushi tilbud'
        }
    },
    {
        path:'/takeaway/:id',
        component:() => import('../views/pages/IndexView.vue'),
        meta: { 
            title: 'Takeaway Menu | Sushi Menu',
            description: 'Gennemse vores takeaway menu og sushi menu, bestil frisk sushi online',
            keywords: 'Takeaway menu, sushi menu, online bestilling, frisk sushi'
        }
    },
    {
        path:'/takeaway/paymentSuccess/:id',
        component:() => import('../views/results/PaymentSuccess.vue'),
        meta: { 
            title: 'Betaling Lykkedes | Lucky Satr',
            description: 'Din betaling er blevet succesfuldt behandlet. Tak for din bestilling',
            keywords: 'betaling lykkedes, ordre bekræftelse, sushi ordre'
        }
    },
    {
        path:'/takeaway/paymentFailed/:id',
        component:() => import('../views/results/PaymentFailed.vue'),
        meta: { 
            title: 'Betaling Mislykkedes',
            description: 'Din betaling var ikke succesfuld. Prøv venligst igen eller kontakt os for hjælp.',
            keywords: 'betaling mislykkedes, betaling fejl, sushi ordre'
        }
    },
    {
        path:'/takeaway/cartList/:id',
        component:() => import('../views/pages/CartListView.vue'),
        meta: { 
            title: 'Leveringstid',
            description: 'Vælg din leveringstid og afslut din ordre.',
            keywords: 'leveringstid, ordre afslutning, sushi levering'
        }
    },
    {
        path:'/takeaway/buyerInfo/:id',
        component:() => import('../views/pages/BuyerInfoView.vue'),
        meta: { 
            title: 'Leveringsoplysninger',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering'
        }
    },
    {
        path:'/contact/:tempId/:customId/:id',
        component:() => import('../views/pages/BookingTable.vue'),
        meta: { 
            title: 'Kontakt & Booking',
            description: 'Kontakt og lav en bordreservation til dit næste besøg.',
            keywords: 'kontakt, booking, bordreservation, sushi restaurant'
        }
    },
    {
        path:'/info/:tempId/:customId/:id',
        component:() => import('../views/pages/CustomView.vue'),
        meta: { 
            title: 'Information',
            description: 'Lær mere om, vores menu og tjenester.',
            keywords: 'information, om os, sushi restaurant, tjenester'
        }
    },
    {
        path:'/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/pages/AllYouCanEat.vue'),
        meta: { 
            title: 'All You Can Eat',
            description: 'Nyd vores all-you-can-eat sushi menu. Ubegrænset sushi til en fast pris.',
            keywords: 'all you can eat, ubegrænset sushi, fast pris, sushi buffet'
        }
    },
    {
        path:'/register/:tempId/:id',
        component:() => import('../views/pages/Register.vue'),
        meta: { 
            title: 'Registrering',
            description: 'Opret en konto for at nyde hurtigere checkout og ordrehistorie.',
            keywords: 'registrering, opret konto, sushi ordre, hurtigere checkout'
        }
    },
    {
        path:'/login/:tempId/:id',
        component:() => import('../views/pages/Login.vue'),
        meta: { 
            title: 'Login',
            description: 'Log ind på din konto for at få adgang til din ordrehistorie og præferencer.',
            keywords: 'login, konto adgang, ordrehistorie, præferencer'
        }
    },
    {
        path:'/userCenter/:tempId/:id',
        component:() => import('../views/pages/UserCenter.vue'),
        meta: { 
            title: 'Brugercenter',
            description: 'Administrer din konto, se ordrehistorie og opdater dine præferencer.',
            keywords: 'brugercenter, konto administration, ordrehistorie, præferencer'
        }
    },
    //mobile
    {
        path:'/mobile/index',
        component:() => import('../views/mobile/Index.vue'),
        meta: { 
            title: 'Sushi Takeaway & Levering',
            description: 'Tilbyder frisk sushi takeaway og levering ',
            keywords: 'sushi, takeaway, levering, køge, greve, slagelse, sushi i køge, sushi i slagelse, sushi i greve, japansk mad, sushi menu, frisk sushi, mobil',
            h1Title: 'Sushi Takeaway & Levering ' 
        }
    },
    {
        path:'/mobile/login/:id',
        component:() => import('../views/mobile/Login.vue'),
         meta: { 
            title: 'Login | Konto Adgang',
            description: 'Log ind på din konto for at få adgang til din ordrehistorie og præferencer. Håndter dine præferencer og se din ordrehistorie på vores mobile platform.',
            keywords: 'login, konto adgang, ordrehistorie, præferencer, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/userCenter/:id',
        component:() => import('../views/mobile/UserCenter.vue'),
        meta: { 
            title: 'Brugercenter | Konto Administration',
            description: 'Administrer din konto, se ordrehistorie og opdater dine præferencer. Håndter din konto administration og se din ordrehistorie på vores mobile platform.',
            keywords: 'brugercenter, konto administration, ordrehistorie, præferencer, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/userInfo/:id',
        component:() => import('../views/mobile/UserInfo.vue'),
         meta: { 
            title: 'Brugeroplysninger | Personlige Detaljer | Lucky Satr',
            description: 'Opdater dine personlige oplysninger og præferencer hos Lucky Satr. Håndter dine personlige detaljer og præferencer på vores mobile platform.',
            keywords: 'brugeroplysninger, personlige detaljer, præferencer, mobil',
            h1Title: 'Lucky Satr – Sushi Takeaway & Levering i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/forget/:id',
        component:() => import('../views/mobile/Forget.vue'),
         meta: { 
            title: 'Glemt Kodeord | Nulstil Kodeord',
            description: 'Nulstil dit kodeord for din konto. Genopret din konto adgang via vores mobile platform.',
            keywords: 'glemt kodeord, nulstil kodeord, konto genoprettelse, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/myOrder/:id',
        component:() => import('../views/mobile/MyOder.vue'),
         meta: { 
            title: 'Mine Ordre | Ordrehistorie',
            description: 'Se din ordrehistorie og spore dine aktuelle ordre. Håndter og spor dine ordre via vores mobile platform.',
            keywords: 'mine ordre, ordrehistorie, spor ordre, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/:id',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            title: 'Takeaway Menu | Sushi Menu',
            description: 'Gennemse vores takeaway menu og sushi menu, bestil frisk sushi online fra via vores mobile platform.',
            keywords: 'takeaway menu, sushi menu, online bestilling, frisk sushi, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        name:'mobileFoodList',
        path:'/mobile/takeaway/foodlist/:id',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            title: 'Madliste | Sushi Menu',
            description: 'Gennemse vores madmenu og sushi menu, vælg dine favorit sushi varer via vores mobile platform.',
            keywords: 'madliste, sushi menu, vælg varer, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
   
    {
        path:'/mobile/takeaway/cartlist/:id',
        component:() => import('../views/mobile/CartListView.vue'),
        meta: { 
            title: 'Indkøbskurv | Ordre Gennemse',
            description: 'Gennemse din ordre, foretag ændringer og gennemfør checkout  via vores mobile platform.',
            keywords: 'indkøbskurv, ordre gennemse, checkout, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id',
        component:() => import('../views/mobile/TimeView.vue'),
        meta: { 
            title: 'Leveringstid',
            description: 'Vælg din foretrukne leveringstid for din sushi ordre.',
            keywords: 'leveringstid, vælg tid, sushi levering, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            title: 'Leveringsoplysninger',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/success/:id',
        component:() => import('../views/mobile/OrderSuccessView.vue'),
         meta: { 
            title: 'Ordre Lykkedes',
            description: 'Din ordre er blevet succesfuldt placeret. Tak for at vælge',
            keywords: 'ordre lykkedes, ordre bekræftelse, sushi ordre, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/detail/:id',
        component:() => import('../views/mobile/OrderDetailsView.vue'),
       meta: { 
            title: 'Ordredetaljer',
            description: 'Se detaljerne af din ordre.',
            keywords: 'ordredetaljer, ordre information, sushi ordre, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/contact/:tempId/:customId/:id',
        component:() => import('../views/mobile/BookingTable.vue'),
        meta: { 
            title: 'Kontakt & Booking',
            description: 'Kontakt og lav en bordreservation til dit næste besøg.',
            keywords: 'kontakt, booking, bordreservation, sushi restaurant, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/mobile/AllYouCanEat.vue'),
         meta: { 
            title: 'All You Can Eat',
            description: 'Nyd vores all you can eat sushi menu. Ubegrænset sushi til en fast pris.',
            keywords: 'all you can eat, ubegrænset sushi, fast pris, sushi buffet, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    //demo 
    {
        path:'/mobile/takeaway/:id/:foodTypeId',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            title: 'Takeaway Menu',
            description: 'Gennemse vores takeaway menu efter kategori og bestil frisk sushi online.',
            keywords: 'takeaway menu, sushi menu, online bestilling, frisk sushi, mobil, madkategori',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/foodlist/:id/:foodTypeId/:foodTypeName/:showType',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            title: 'Madliste',
            description: 'Gennemse vores madmenu efter kategori og vælg dine favorit sushi varer.',
            keywords: 'madliste, sushi menu, vælg varer, mobil, madkategori',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id/:deliveryTip',
        component:() => import('../views/mobile/TimeView.vue'),
         meta: { 
            title: 'Leveringstid',
            description: 'Vælg din foretrukne leveringstid for din sushi ordre.',
            keywords: 'leveringstid, vælg tid, sushi levering, mobil, leveringsbetingelser',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id/:deliveryTip',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            title: 'Leveringsoplysninger',
            description: 'Indtast dine leveringsoplysninger og afslut din ordre.',
            keywords: 'leveringsoplysninger, ordredetaljer, sushi levering, mobil, leveringsbetingelser',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/mobile/info/:tempId/:customId/:id',
        component:() => import('../views/mobile/CustomView.vue'),
         meta: { 
            title: 'Information',
            description: 'Lær mere om, vores menu og tjenester.',
            keywords: 'information, om os, sushi restaurant, tjenester, mobil',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
        path:'/b/takeaway/:id',
        component:() => import('../views/takeaway02/IndexView.vue'),
        meta: { 
            title: 'Takeaway',
            description: 'Bestil frisk sushi online. Vi tilbyder takeaway og leveringstjenester.',
            keywords: 'takeaway, online bestilling, frisk sushi, leveringstjenester'
        }
    },
    {
        path:'/b/checkout/:id',
        component:() => import('../views/takeaway02/Checkout.vue'),
        meta: { 
            title: 'Checkout',
            description: 'Afslut din ordre og foretag betaling.',
            keywords: 'checkout, betaling, ordre afslutning, sushi ordre',
            keepAlive: false 
        }
    },
    {
        path:'/b/order/:id',
        component:() => import('../views/takeaway02/OrderDetial.vue'),
        meta: { 
            title: 'Min Ordre',
            description: 'Se detaljerne af din ordre.',
            keywords: 'min ordre, ordredetaljer, ordre information, sushi ordre'
        }
    },
    {
        path:'/b/show/:activeIndex/:id',
        component:() => import('../views/takeaway02/Custom.vue'),
        meta: { 
            title: 'Info',
            description: 'Lær mere om, vores menu og tjenester.',
            keywords: 'info, om os, sushi restaurant, menu, tjenester'
        }
    },
    {
        path:'/b/cartList/:id',
        component:() => import('../views/takeaway02/CartList.vue'),
        meta: { 
            title: 'Kurvliste',
            description: 'Gennemse din ordre og foretag ændringer før checkout.',
            keywords: 'kurvliste, ordre gennemse, checkout, sushi ordre'
        }
    },
    {
        path:'/booking/:id',
        component:() => import('../views/booking/Index.vue'),
        meta: { 
            title: 'Booking',
            description: 'Lav en bordreservation til dit næste besøg.',
            keywords: 'booking, bordreservation, sushi restaurant, reservation'
        }
    },
     {
        path:'/e-invoice/:type/:id',
        component:() => import('../views/bill/Index.vue'),
        meta: { 
            title: 'E-faktura',
            description: 'Se og download din e-faktura for ordre.',
            keywords: 'e-faktura, faktura, download faktura, ordre faktura'
        }
    },
      {
        path:'/pre-invoice/:type/:id',
        component:() => import('../views/bill/Preview.vue'),
        meta: { 
            title: 'E-faktura Forhåndsvisning',
            description: 'Forhåndsvis din e-faktura for ordre.',
            keywords: 'e-faktura forhåndsvisning, faktura forhåndsvisning, ordre faktura'
        }
    },
      {
        path:'/booking/edit/:id',
        component:() => import('../views/booking/EditBookingTable.vue'),
        meta: { 
            title: 'Rediger Booking',
            description: 'Rediger din bordreservation.',
            keywords: 'rediger booking, modificer reservation, bordreservation'
        }
    },
    {
      path: '/blog/:id',
      name: 'blog',
      component: () => import('@/views/blog/BlogList.vue'),
      meta: { 
            title: 'Blog',
            description: 'Læs vores seneste blogindlæg om sushi, japansk mad og vores filosofi.',
            keywords: 'blog, sushi, japansk mad, Lucky Satr, køge, greve, slagelse',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    },
    {
      path: '/blog/detail/:id',
      name: 'blog-detail',
      component: () => import('@/views/blog/BlogDetail.vue'),
      meta: { 
            title: 'Blog Details',
            description: 'Læs detaljerede blogindlæg om sushi, japansk mad og vores filosofi.',
            keywords: 'blog details, sushi, japansk mad, Lucky Satr, køge, greve, slagelse',
            h1Title: 'Sushi Takeaway & Levering' 
        }
    }
]
// 在方法或计算属性中
